import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { FlxAccordionModule } from '@flowx/angular-ui-toolkit'
import { DataModelPathReferences } from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import { DataModelResourceType } from '@flowx/designer/shared/api/data-model.api'

import { AttributeReferencesComponent } from '../attribute-references/attribute-references.component'

@Component({
  selector: 'flx-entity-references',
  imports: [CommonModule, AttributeReferencesComponent, FlxAccordionModule],
  templateUrl: './entity-references.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './entity-references.component.scss',
})
export class EntityReferencesComponent {
  path = input.required<string>()
  references = input.required<DataModelPathReferences[]>()
  isCollapsable = input<boolean>(false)
  isCollapsed = input<boolean>(true)
  resourceType = input.required<DataModelResourceType>()

  header = computed(() => `${this.path()}{}`)
}
